export default "__VITE_ASSET__Hbk0eJHG__"